import styled from 'styled-components';
import React from "react";
import Button from "@material-ui/core/Button";
import {green_style, gray_style} from "../styles"


function MyButton(props) {
  let ButtonStyle = props.cursor ? gray_style : green_style

  return(
      <Button
          style = {ButtonStyle}
          type="button"
          fullWidth
          variant="contained"
          onClick={props.onClick}
          disabled={props.cursor}
      >     
          {props.text}
      </Button>
  );
}

export default MyButton

